import styles from "./ApaKataMereka.module.css"
import CardKesan from "./components/CardKesan"
import { Swiper, SwiperSlide } from "swiper/react"

import iconNext from "./assets/arrow-right-green.svg"
import iconPrev from "./assets/arrow-left-green.svg"
import iconNextDisabled from "./assets/arrow-right.svg"
import iconPrevDisabled from "./assets/arrow-left.svg"
import female from "./assets/female.png"
import male from "./assets/male.png"

import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import { Pagination, Navigation } from "swiper/modules"
import { useState } from "react"

const ApaKataMereka = () => {
  const [isBeginning, setIsBeginning] = useState(true)
  const [isEnd, setIsEnd] = useState(false)

  return (
    <div className={styles.body} data-aos="fade-up">
      <div className="container">
        <div className={styles.topdesc}>
          <div className="left">
            <h1 className={styles.header}>Apa Kata Mereka?</h1>
            <p className={styles.desc}>
              Lihat kata mereka yang sudah mengikuti <br /> program training di
              Mindo
            </p>
          </div>

          <div className={styles.right}>
            <button
              className={`btn-prev ${styles.btnPrev} ${
                !isBeginning ? styles.btnActive : ""
              }`}
              disabled={isBeginning}>
              <img src={isBeginning ? iconPrevDisabled : iconPrev} alt="prev" />
            </button>

            <button
              className={`btn-next ${styles.btnNext} ${
                !isEnd ? styles.btnActive : ""
              }`}
              disabled={isEnd}>
              <img src={isEnd ? iconNextDisabled : iconNext} alt="next" />
            </button>
          </div>
        </div>

        <div className={styles.cardKesanSwipe}>
          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            loop={false}
            pagination={{ clickable: true }}
            navigation={{
              nextEl: ".btn-next",
              prevEl: ".btn-prev",
            }}
            modules={[Navigation, Pagination]}
            breakpoints={{
              0: {
                slidesPerView: 1, // mobile kecil
              },
              767: {
                slidesPerView: 2, // diatas 767 = 2 page
              },
              1100: {
                slidesPerView: 3, // di atas 1100 = normal
              },
            }}
            onSlideChange={(swiper) => {
              setIsBeginning(swiper.isBeginning)
              setIsEnd(swiper.isEnd)
            }}
            onInit={(swiper) => {
              setIsBeginning(swiper.isBeginning)
              setIsEnd(swiper.isEnd)
            }}
            className={`mySwiper swiperReq`}>
            <SwiperSlide>
              <CardKesan
                tittle="Offline Training"
                topic="FSMS INTEGRATION ISO 22000:2018, HACCP, GMP & SSOP"
                date="01 Juli 2025"
                kesan="Saya merasa sangat terbantu dan mendapatkan banyak wawasan baru setelah mengikuti pelatihan ini. Materi yang disampaikan cukup padat dan relevan dengan kebutuhan di lapangan, terutama dalam hal penerapan prinsip-prinsip pengawasan mutu pangan yang sesuai standar."
                profile={female}
                nama="Dina Putri Patrisia Jalung"
                detail="Prodi Gizi Universitas Respati Yogyakarta"
              />
            </SwiperSlide>
            <SwiperSlide>
              <CardKesan
                tittle="Online Training"
                topic="Quality Control Awareness Training"
                date="02 Maret 2025"
                kesan="Saya jadi lebih memahami terkait peran QC dan QA terutama di bidang industri secara detail dan jelas, materi yang dijelaskan sangat lengkap bahkan dijelaskan juga hal-hal tambahan seperti mil-std-105 sebuah insight baru bagi saya, Terima kasih Mindo Education"
                profile={female}
                nama="Zhafira Az Zahra"
                detail="HMPP Vadra ITB"
              />
            </SwiperSlide>
            <SwiperSlide>
              <CardKesan
                tittle="Offline Training"
                topic="HACCP based on Codex General Principles of Food Hygiene CXC-1969 Rev. 6-2022"
                date="05 februari 2025"
                kesan="Mengetahui materi tentang HACCP yang sebelumnya belum pernah saya dapatkan, melatih hardskill saya dalam menganalisa hazard, serta kesan saya kepada trainer mindo yg komunikatif."
                profile={female}
                nama="Erinna shefa sabia"
                detail="PT Indo Walet Lestari"
              />
            </SwiperSlide>

            <SwiperSlide>
              <CardKesan
                tittle="Online Training"
                topic="SMK3 ISO 45001:2018 for Laboratory"
                date="29 Juni 2024"
                kesan="Mandapatkan insight baru tetentang iso 45001, banyak hal baru yang saya dengar tentang dunia pekerjaan khususnya di laboratorium, dapat menjadi acuan saya saat sedang praktikum di lab dan akan menjadi gambaran untuk saya kedepannya. Terima kasih 🙏🏻🙏🏻✨️"
                profile={female}
                nama="Dinda Putri Amelia"
                detail="LMC UIN Syarif Hidayatullah"
              />
            </SwiperSlide>
            <SwiperSlide>
              <CardKesan
                tittle="Online Training"
                topic="Integrated Training (ISO 22000:2018, GMP, SSOP)"
                date="19 Agustus 2023"
                kesan="Lebih siap untuk melakukan pekerjaan yang berkaitan dengan ISO 22000:2018, terlebih saya melakukan kegiatan Praktik Kerja Lapang (PKL) saat ini pada bagian yang berhubungan erat dengan Quality Assurance dan proses-proses pencatatan dokumen keamanan pangan"
                profile={male}
                nama="Rizal Wahyudi Al-Amin"
                detail="HIMATIPAN UNPAD"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  )
}

export default ApaKataMereka
